import {TranscriptionSentence} from "./TranscriptionSentence";

export class Transcription {
  duration: number = 0;
  timedTexts: TranscriptionSentence[] = [];
  text: string = "";
  jobId: string = "";

  static fromJson(json): Transcription {
    if (!json){
      throw new Error("missing json");
    }

    const transcription = new Transcription();

    transcription.duration = json.duration;
    transcription.text = json.text;
    transcription.jobId = json.jobId;

    if (json.timedTexts){
      transcription.timedTexts = TranscriptionSentence.fromJsonArray(json.timedTexts);
    }

    return transcription;
  }
}



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-edit/shared/Transcription.ts